export default __webpack_public_path__ + "static/media/coverPageInstruction.e4f20cca.png";